export default[
  {value:'M', label:'Masculino'},
  {value:'F', label:'Feminino'},
  {value:'U', label:'Outro'},
  {value:'N', label:'Não informado'},
]
